import React, { useEffect, useState } from "react";
import { TextInput } from "@opendate-app/setlist";

const BlurTextInput = ({ value, onSave, transform = (text) => text, onFocus, ...rest }) => {
  const saved = value || "";
  const [text, setText] = useState(saved);

  useEffect(() => {
    setText(saved);
  }, [saved]);

  const commit = () => {
    const next = text.trim();
    if (next === saved) return;
    onSave(next);
  };

  return (
    <TextInput
      {...rest}
      value={text}
      onFocus={onFocus}
      onChange={(event) => setText(transform(event.target.value))}
      onBlur={commit}
    />
  );
};

export default BlurTextInput;
